import { createContext, useContext } from 'react';

export interface TabPaneContextValue {
  panePath: string;
  isPaneActive: boolean;
}

export const TabPaneContext = createContext<TabPaneContextValue | null>(null);

export const useTabPaneContext = (): TabPaneContextValue | null =>
  useContext(TabPaneContext);
